import {
  Box,
  Container,
  LinearProgress,
  Grid
} from '@material-ui/core';
import TotalDownloads from 'src/components/dashboard//TotalDownloads';
import TotalCustomers from 'src/components/dashboard//TotalCustomers';
import TotalDataVolume from 'src/components/dashboard//TotalDataVolume';
import DistributionByCountrys from 'src/components/dashboard/DistributionByCountrys';
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import NumberOfDownloads from 'src/components/dashboard/NumberOfDownloads';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import axios from 'axios';
import React from 'react';
import { checkAutoLogin } from 'src/actions/getTokenActions';


const Dashboard = React.memo(() => {
  const [graphdata, setgraphdata] = useState([]);
  const [graphdata1, setgraphdata1] = useState([]);
  const [totalyearkw, settotalyearkw] = useState([]);
  const [rztotalyearkw, setrztotalyearkw] = useState([]);
  const [rz1totalyearkw, setrz1totalyearkw] = useState([]);
  const [rz, setrz] = useState([]);
  const [rz1, setrz1] = useState([]);
  const [accountdata, setaccountdata] = useState([]);
  const [progress, setprogress] = useState(false);

  let currentYear = new Date().getFullYear()
  const [year, setyear] = useState(currentYear);
  const isLogin = useSelector(state => state.gettocken.islogin);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const apiurl = sessionStorage.getItem('apiurl')

  useEffect(() => {
    setprogress(true)
    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    } else {
      axios.get(`https://${apiurl}/api/Dashboard?year=${year}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        }
      }).then(res => {

        console.log(res.data)
        let accountdataraw = res.data.donut.filter(function (item) {
          return item.accountId !== 1;
        });

        // Balken
        setgraphdata(res.data.diagramm[0].monthValue)
        setrz(res.data.diagramm[0].dataCenterName)
        setgraphdata1(res.data.diagramm[1].monthValue)
        setrz1(res.data.diagramm[1].dataCenterName)
        // RZ1
        setrztotalyearkw(res.data.diagramm[0].totalValue.toFixed(2))
        //RZ2
        setrz1totalyearkw(res.data.diagramm[1].totalValue.toFixed(2))

        // Donat
        setaccountdata(accountdataraw)

        // Gesamt
        let totalkw = res.data.totalValue.toFixed(2)
        settotalyearkw(totalkw)
        setyear(res.data.year)
        setprogress(false)

      }).catch(ex => console.error(ex));
    }
  }, [isLogin, year]);


  const requestDataForYear = (year) => {
    setyear(year)
  }

  console.log(accountdata)

  return (
    <>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >

        <Container maxWidth={false}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              lg={4}
              sm={6}
              xl={4}
              xs={12}
            >
              <TotalDownloads totalDownloads={totalyearkw} year={year} style={{ backgroundColor: '#f3f3f3' }} />
            </Grid>
            <Grid
              item
              lg={4}
              sm={6}
              xl={4}
              xs={12}
            >
              <TotalCustomers rztotalyearkw={rztotalyearkw} year={year} rz={rz} style={{ backgroundColor: '#f3f3f3' }} />
            </Grid>
            <Grid
              item
              lg={4}
              sm={12}
              xl={4}
              xs={12}
            >
              <TotalDataVolume rz1totalyearkw={rz1totalyearkw} year={year} rz1={rz1} style={{ backgroundColor: '#f3f3f3' }}/>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth >
          {progress &&
            <LinearProgress />
          }
        </Container>
        <Container maxWidth={false}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              lg={8}
              md={8}
              xl={8}
              xs={12}
              mt={12}
            >
              <NumberOfDownloads requestDataForYear={requestDataForYear} currentYear={year} graphdata={graphdata} graphdata1={graphdata1} rz={rz} rz1={rz1} />
            </Grid>

            <Grid
              item
              lg={4}
              md={4}
              xl={4}
              xs={12}
              mt={12}
            >
              <DistributionByCountrys accountdata={accountdata} />
            </Grid>

          </Grid>
        </Container>
      </Box>
    </>
  );
});

export default Dashboard;
